/**
 * NAKED · calculateur de taille v2 · textes.
 * window.NakedSizeTexts = { fr: { cle: texte }, en, de, nl, it, pl, da, sv, t(lang, cle, variables) }.
 * Le français est la langue de repli : une langue inconnue (pt-BR) ou une clé absente d'une langue s'affiche en français.
 * Le bloc TEXTS est GÉNÉRÉ à partir de src/texts-<langue>.json par `node tests/build-template.mjs` :
 * modifier les JSON, pas ce bloc. Mêmes clés et mêmes variables dans chaque langue (contrôlé par les tests).
 */
(function (root) {
  'use strict';

  /* TEXTES:DEBUT (généré par tests/build-template.mjs à partir de src/texts-<langue>.json : ne pas modifier à la main) */
  var TEXTS = {
    fr: {
      card_size_set: "Votre taille : haut {top} · bas {bottom}",
      card_size_single: "Votre taille : {size}",
      card_soldout: "Votre taille {size} est épuisée",
      card_not_advised: "Taille à vérifier pour ce modèle",
      card_out: "Pas de taille conseillée pour ce modèle",
      card_edit: "Modifier",
      card_sub: "Répondez à quelques questions et obtenez votre taille idéale.",
      dialog_title: "Trouver ma taille",
      progress: "Étape {n} sur {total}",
      close: "Fermer le calculateur de taille",
      previous: "Retour",
      next: "Suivant",
      see_result_btn: "Voir ma taille",
      edit_answers: "Modifier mes réponses",
      profile_title: "Votre profil",
      profile_sub: "Taille, poids et âge : trois repères pour commencer.",
      height_label: "Taille",
      weight_label: "Poids",
      age_label: "Âge",
      unit_cm: "cm",
      unit_ft: "pieds",
      unit_in: "pouces",
      unit_kg: "kg",
      unit_lb: "livres",
      unit_years: "ans",
      unit_choice_aria: "Unité",
      step_minus_aria: "{champ} : diminuer",
      step_plus_aria: "{champ} : augmenter",
      belly_title: "Quel ventre ressemble le plus au vôtre ?",
      belly_flat: "Plat",
      belly_average: "Moyen",
      belly_round: "Avec des rondeurs",
      hips_title: "Quelles hanches ressemblent le plus aux vôtres ?",
      hips_narrow: "Étroites",
      hips_average: "Moyennes",
      hips_curved: "Courbées",
      seat_title: "Quelles fesses ressemblent le plus aux vôtres ?",
      seat_flat: "Plates",
      seat_average: "Moyennes",
      seat_round: "Rondes",
      region_current: "{systeme_titre} · ex. {exemple}",
      region_change_btn: "Changer",
      region_picker_title: "Quelles tailles utilisez-vous ?",
      region_fr: "Tailles françaises",
      region_fr_countries: "France, Belgique, Espagne",
      region_eu: "Tailles allemandes",
      region_eu_countries: "Allemagne, Pays-Bas, Autriche, Suisse, Danemark, Suède, Pologne",
      region_it: "Tailles italiennes",
      region_it_countries: "Italie",
      region_us: "Tailles US",
      region_us_countries: "États-Unis, Canada",
      region_uk: "Tailles UK",
      region_uk_countries: "Royaume-Uni, Irlande",
      region_au: "Tailles australiennes",
      region_au_countries: "Australie, Nouvelle-Zélande",
      system_inline_fr: "tailles françaises",
      system_inline_eu: "tailles allemandes",
      system_inline_it: "tailles italiennes",
      system_inline_us: "tailles US",
      system_inline_uk: "tailles UK",
      system_inline_au: "tailles australiennes",
      bra_title: "Votre taille de soutien-gorge",
      bra_sub: "Celle que vous portez le plus souvent, même si elle n'est pas parfaite.",
      band_size: "Tour de dos (le chiffre)",
      cup_size: "Bonnet (la lettre)",
      band_plus_aria: "{n} ou plus",
      cup_plus_aria: "{c} ou plus",
      cup_small_aria: "AA ou A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} en France",
      equiv_eu: "{taille} en Allemagne",
      equiv_it: "{taille} en Italie",
      equiv_us: "{taille} aux États-Unis",
      equiv_uk: "{taille} au Royaume-Uni",
      equiv_au: "{taille} en Australie",
      bra_unknown_link: "Je ne connais pas ma taille",
      fallback_title: "Sans taille de soutien-gorge",
      fallback_sub: "Deux questions suffisent. Le résultat sera une estimation.",
      fallback_top_label: "Votre taille de haut habituelle",
      fallback_top_help: "Celle de vos tee-shirts ou de vos chemisiers.",
      fallback_bust_label: "À la poitrine, vos hauts sont souvent",
      bust_small: "Un peu larges",
      bust_medium: "À la bonne taille",
      bust_full: "Un peu serrés",
      fallback_back_link: "Saisir ma taille de soutien-gorge",
      bottom_title: "Votre taille de bas habituelle",
      bottom_help: "Celle de vos pantalons ou de vos culottes.",
      bottom_last_pill: "{limite} et plus",
      error_bra_none: "Choisissez votre tour de dos et votre bonnet.",
      error_band_missing: "Il manque votre tour de dos (le chiffre).",
      error_cup_missing: "Il manque votre bonnet (la lettre).",
      error_top_missing: "Choisissez votre taille de haut.",
      error_bust_missing: "Choisissez l'une des trois réponses.",
      error_bottom_missing: "Choisissez votre taille de bas.",
      error_height_cm: "Indiquez votre taille, entre {mini} et {maxi} cm.",
      error_height_ft: "Indiquez votre taille, entre {mini} et {maxi}.",
      error_weight_kg: "Indiquez votre poids, entre {mini} et {maxi} kg.",
      error_weight_lb: "Indiquez votre poids, entre {mini} et {maxi} livres.",
      error_age: "Indiquez votre âge, entre {mini} et {maxi} ans.",
      error_morpho_missing: "Choisissez l'option qui vous ressemble le plus.",
      error_generic: "Le calcul n'a pas fonctionné. Vérifiez vos réponses et réessayez.",
      result_title: "Votre taille idéale",
      result_out_title: "Ce modèle risque d'être trop petit",
      result_compromise_title: "Ce modèle sera un compromis",
      result_none_title: "Nous n'avons pas votre taille",
      result_capped_title: "Ce modèle s'arrête au {max}",
      result_oos_title: "Votre taille est épuisée",
      top_size: "Haut",
      bottom_size: "Bas",
      body_size: "Body",
      single_size: "Taille",
      result_none_value: "-",
      result_max_tag: "Notre plus grande taille",
      result_closest_tag: "La plus proche",
      result_none_tag: "Aucune taille",
      result_capped_tag: "Non proposée sur ce modèle",
      result_oos_tag: "Épuisée",
      result_fit_line: "S'adapte parfaitement à votre morphologie",
      social_proof_single: "Nos clientes ayant votre morphologie choisissent cette taille",
      social_proof_set: "Nos clientes ayant votre morphologie choisissent ces tailles pour leur ensemble",
      result_why: "Calculé à partir de votre soutien-gorge {sg} et de votre taille de bas {bas_saisi}.",
      result_why_system: "Calculé à partir de votre soutien-gorge {sg} ({systeme}) et de votre taille de bas {bas_saisi}.",
      result_why_fallback: "Estimé à partir de votre taille de haut {haut_saisi}, de vos réponses et de votre taille de bas {bas_saisi}.",
      result_why_profile: "Calculé à partir de votre profil, de votre soutien-gorge {sg} et de votre taille de bas {bas_saisi}.",
      result_why_profile_system: "Calculé à partir de votre profil, de votre soutien-gorge {sg} ({systeme}) et de votre taille de bas {bas_saisi}.",
      result_why_profile_fallback: "Estimé à partir de votre profil, de votre taille de haut {haut_saisi}, de vos réponses et de votre taille de bas {bas_saisi}.",
      result_fallback_help: "C'est une estimation : sans taille de soutien-gorge, le calcul est moins précis.",
      tiebreak_top_title: "En haut, vous êtes entre {petite} et {grande}.",
      tiebreak_single_title: "Vous êtes entre {petite} et {grande}.",
      tiebreak_advised_badge: "Conseillée",
      tiebreak_hi_advised_help: "Si votre {sg} vous va bien ou vous serre.",
      tiebreak_lo_other_help: "Si votre {sg} est un peu grand.",
      tiebreak_lo_advised_help: "Si votre {sg} vous va bien ou est un peu grand.",
      tiebreak_hi_other_help: "Si votre {sg} vous serre.",
      tiebreak_hi_advised_help_approx: "Si vos hauts vous vont bien ou vous serrent.",
      tiebreak_lo_other_help_approx: "Si vos hauts sont souvent un peu grands.",
      tiebreak_lo_advised_help_approx: "Si vos hauts vous vont bien ou sont un peu grands.",
      tiebreak_hi_other_help_approx: "Si vos hauts vous serrent souvent.",
      warn_none_cup: "Nos tailles s'arrêtent au {max}. Pour un {sg}, le bonnet du {max} est trop petit.",
      warn_none_band: "Nos tailles s'arrêtent au {max}. Pour un tour de dos {tour}, il ne ferme pas.",
      warn_none_approx: "Nos tailles s'arrêtent au {max}. Pour une taille de haut {haut_saisi}, il est trop petit.",
      warn_none_bottom: "Nos bas s'arrêtent au {max}. Pour une taille {bas_saisi}, il est trop petit.",
      warn_none_bottom_single: "Nos tailles s'arrêtent au {max}. Pour une taille de bas {bas_saisi}, il est trop petit.",
      warn_out_frank: "Nous préférons vous le dire avant la commande.",
      warn_out_cup_max: "Pour un {sg}, même notre {max} risque d'être trop petit au bonnet.",
      warn_out_cup: "Pour un {sg}, le bonnet du {taille} risque d'être trop petit.",
      warn_out_band: "Pour un tour de dos {tour}, même notre {max} risque d'être trop court pour s'attacher.",
      warn_out_bottom: "Pour une taille de bas {bas_saisi}, même notre {max} risque d'être trop petit.",
      warn_out_bottom_single: "Pour une taille de bas {bas_saisi}, même notre {max} risque d'être trop petit aux hanches.",
      warn_out_approx: "Pour une taille de haut {haut_saisi}, même notre {max} risque d'être trop petit.",
      warn_compromise: "Pour un bonnet {bonnet}, nous avons choisi la taille du bonnet. Le tour de dos sera large.",
      warn_capped_top: "Ce modèle s'arrête au {max}. Pour un {sg}, il risque d'être juste au bonnet.",
      warn_capped_bottom: "Ce modèle s'arrête au {max}. Pour une taille de bas {bas_saisi}, il risque d'être trop petit.",
      warn_capped_generic: "Ce modèle s'arrête au {max}. Votre taille serait le {taille} : le {max} risque d'être trop petit.",
      warn_oos_single: "Le {taille} est épuisé sur ce modèle. Mieux vaut ne pas prendre une autre taille à la place.",
      warn_oos_set: "Haut {haut} · bas {bas} : cette combinaison est épuisée sur ce modèle. Mieux vaut ne pas prendre une autre taille à la place.",
      warn_oos_frontier: "Le {taille} est épuisé sur ce modèle. Le {autre} est disponible.",
      warn_body_top_bigger: "Haut {haut}, bas {bas} : un body sera un compromis. En {taille}, il suit votre poitrine et sera large aux hanches.",
      warn_body_bottom_bigger: "Haut {haut}, bas {bas} : un body sera un compromis. En {taille}, il suit vos hanches et sera trop grand à la poitrine.",
      warn_body_alt: "Avec un ensemble, vous choisissez une taille en haut et une autre en bas.",
      warn_body_alt_btn: "Voir les ensembles",
      warn_runs_small: "Ce modèle taille petit : nous conseillons le {grande} plutôt que le {petite}.",
      warn_limit_bottom: "En {bas_saisi}, vous êtes à la limite de notre {max}. Le bas risque d'être juste.",
      warn_limit_bottom_single: "En {bas_saisi}, vous êtes à la limite de notre {max}. Il risque d'être juste aux hanches.",
      warn_cup_tight: "En {taille}, le tour de dos correspond. Le bonnet risque d'être un peu juste pour un {sg}.",
      warn_cup_tight_approx: "En {taille}, le haut risque d'être un peu juste à la poitrine.",
      warn_cup_a_smallest: "Avec un bonnet {bonnet}, le bonnet du S risque de bâiller un peu. Nous n'avons pas de bonnet plus petit.",
      warn_cup_a_other: "Avec un bonnet {bonnet}, le bonnet du {taille} risque de bâiller un peu.",
      warn_gape_approx: "En {taille}, le bonnet risque de bâiller un peu.",
      cta_set_btn: "Choisir haut {haut} · bas {bas}",
      cta_body_btn: "Choisir la taille {taille}",
      cta_close_btn: "Fermer",
      cta_anyway_btn: "Choisir quand même le {taille}",
      cta_anyway_set_btn: "Choisir quand même haut {haut} · bas {bas}",
      apply_failed: "La taille n'a pas pu être sélectionnée. Choisissez {tailles} sur la fiche.",
      apply_failed_soldout: "Cette taille vient d'être épuisée sur ce modèle.",
      apply_sizes_set: "haut {haut} et bas {bas}",
      apply_sizes_single: "la taille {taille}",
      reassurance: "Remboursement ou échange sous 14 jours",
      memory_info: "Votre taille reste enregistrée sur cet appareil pour la pré-sélectionner sur les autres modèles. Vous pouvez la modifier ou l'effacer à tout moment.",
      memory_clear_btn: "Effacer",
      aria_result_set: "Taille conseillée : haut {haut}, bas {bas}.",
      aria_result_body: "Taille conseillée : {taille}."
    },
    en: {
      card_size_set: "Your size: top {top} · bottom {bottom}",
      card_size_single: "Your size: {size}",
      card_soldout: "Your size {size} is sold out",
      card_not_advised: "Double-check the size for this style",
      card_out: "No recommended size for this style",
      card_edit: "Edit",
      card_sub: "Answer a few questions and get your ideal size.",
      dialog_title: "Find my size",
      progress: "Step {n} of {total}",
      close: "Close the size finder",
      previous: "Back",
      next: "Next",
      see_result_btn: "See my size",
      edit_answers: "Change my answers",
      profile_title: "Your profile",
      profile_sub: "Height, weight and age: three quick details to start.",
      height_label: "Height",
      weight_label: "Weight",
      age_label: "Age",
      unit_cm: "cm",
      unit_ft: "ft",
      unit_in: "in",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "years",
      unit_choice_aria: "Unit",
      step_minus_aria: "{champ}: decrease",
      step_plus_aria: "{champ}: increase",
      belly_title: "Which belly shape looks most like yours?",
      belly_flat: "Flat",
      belly_average: "Average",
      belly_round: "Rounded",
      hips_title: "Which hips look most like yours?",
      hips_narrow: "Narrow",
      hips_average: "Average",
      hips_curved: "Curvy",
      seat_title: "Which butt shape looks most like yours?",
      seat_flat: "Flat",
      seat_average: "Average",
      seat_round: "Round",
      region_current: "{systeme_titre} · e.g. {exemple}",
      region_change_btn: "Change",
      region_picker_title: "Which sizes do you use?",
      region_fr: "French sizes",
      region_fr_countries: "France, Belgium, Spain",
      region_eu: "German sizes",
      region_eu_countries: "Germany, Netherlands, Austria, Switzerland, Denmark, Sweden, Poland",
      region_it: "Italian sizes",
      region_it_countries: "Italy",
      region_us: "US sizes",
      region_us_countries: "United States, Canada",
      region_uk: "UK sizes",
      region_uk_countries: "United Kingdom, Ireland",
      region_au: "Australian sizes",
      region_au_countries: "Australia, New Zealand",
      system_inline_fr: "French sizes",
      system_inline_eu: "German sizes",
      system_inline_it: "Italian sizes",
      system_inline_us: "US sizes",
      system_inline_uk: "UK sizes",
      system_inline_au: "Australian sizes",
      bra_title: "Your bra size",
      bra_sub: "The one you wear most, even if it's not a perfect fit.",
      band_size: "Band (the number)",
      cup_size: "Cup (the letter)",
      band_plus_aria: "{n} or larger",
      cup_plus_aria: "{c} or larger",
      cup_small_aria: "AA or A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} in France",
      equiv_eu: "{taille} in Germany",
      equiv_it: "{taille} in Italy",
      equiv_us: "{taille} in the US",
      equiv_uk: "{taille} in the UK",
      equiv_au: "{taille} in Australia",
      bra_unknown_link: "I don't know my bra size",
      fallback_title: "No bra size needed",
      fallback_sub: "Just two questions. Your result will be an estimate.",
      fallback_top_label: "Your usual top size",
      fallback_top_help: "What you wear in T-shirts or blouses.",
      fallback_bust_label: "At the bust, your tops are usually",
      bust_small: "A bit loose",
      bust_medium: "Just right",
      bust_full: "A bit tight",
      fallback_back_link: "Enter my bra size",
      bottom_title: "Your usual bottoms size",
      bottom_help: "The size you wear in pants or dresses.",
      bottom_last_pill: "{limite}+",
      error_bra_none: "Pick your band and cup size.",
      error_band_missing: "Your band size is missing (the number).",
      error_cup_missing: "Your cup size is missing (the letter).",
      error_top_missing: "Pick your top size.",
      error_bust_missing: "Pick one of the three answers.",
      error_bottom_missing: "Pick your bottoms size.",
      error_height_cm: "Enter your height, between {mini} and {maxi} cm.",
      error_height_ft: "Enter your height, between {mini} and {maxi}.",
      error_weight_kg: "Enter your weight, between {mini} and {maxi} kg.",
      error_weight_lb: "Enter your weight, between {mini} and {maxi} lb.",
      error_age: "Enter your age, between {mini} and {maxi}.",
      error_morpho_missing: "Pick the shape that looks most like yours.",
      error_generic: "Something went wrong. Check your answers and try again.",
      result_title: "Your perfect size",
      result_out_title: "This style may be too small",
      result_compromise_title: "This style will be a compromise",
      result_none_title: "We don't carry your size",
      result_capped_title: "This style only goes up to {max}",
      result_oos_title: "Your size is sold out",
      top_size: "Top",
      bottom_size: "Bottom",
      body_size: "Bodysuit",
      single_size: "Size",
      result_none_value: "-",
      result_max_tag: "Our largest size",
      result_closest_tag: "Closest size",
      result_none_tag: "No size",
      result_capped_tag: "Not available in this style",
      result_oos_tag: "Sold out",
      result_fit_line: "Fits your shape perfectly",
      social_proof_single: "Customers with your shape choose this size",
      social_proof_set: "Customers with your shape choose these sizes for their set",
      result_why: "Based on your {sg} bra size and your size {bas_saisi} bottoms.",
      result_why_system: "Based on your {sg} bra size ({systeme}) and your size {bas_saisi} bottoms.",
      result_why_fallback: "Estimated from your size {haut_saisi} tops, your answers and your size {bas_saisi} bottoms.",
      result_why_profile: "Based on your profile, your {sg} bra size and your size {bas_saisi} bottoms.",
      result_why_profile_system: "Based on your profile, your {sg} bra size ({systeme}) and your size {bas_saisi} bottoms.",
      result_why_profile_fallback: "Estimated from your profile, your size {haut_saisi} tops, your answers and your size {bas_saisi} bottoms.",
      result_fallback_help: "This is an estimate. Without a bra size, the result is less precise.",
      tiebreak_top_title: "On top, you're between {petite} and {grande}.",
      tiebreak_single_title: "You're between {petite} and {grande}.",
      tiebreak_advised_badge: "Recommended",
      tiebreak_hi_advised_help: "If your {sg} fits well or feels tight.",
      tiebreak_lo_other_help: "If your {sg} is a bit loose.",
      tiebreak_lo_advised_help: "If your {sg} fits well or is a bit loose.",
      tiebreak_hi_other_help: "If your {sg} feels tight.",
      tiebreak_hi_advised_help_approx: "If your tops fit well or feel tight.",
      tiebreak_lo_other_help_approx: "If your tops are often a bit loose.",
      tiebreak_lo_advised_help_approx: "If your tops fit well or are a bit loose.",
      tiebreak_hi_other_help_approx: "If your tops often feel tight.",
      warn_none_cup: "Our sizes go up to {max}. For size {sg}, the {max} cup is too small.",
      warn_none_band: "Our sizes go up to {max}. For band size {tour}, it won't fasten.",
      warn_none_approx: "Our sizes go up to {max}. For top size {haut_saisi}, that's too small.",
      warn_none_bottom: "Our bottoms go up to {max}. For size {bas_saisi}, that's too small.",
      warn_none_bottom_single: "Our sizes go up to {max}. For bottoms size {bas_saisi}, that's too small.",
      warn_out_frank: "We'd rather tell you before you order.",
      warn_out_cup_max: "For size {sg}, even our {max} may be too small in the cup.",
      warn_out_cup: "For size {sg}, the {taille} cup may be too small.",
      warn_out_band: "For band size {tour}, even our {max} may be too short to fasten.",
      warn_out_bottom: "For bottoms size {bas_saisi}, even our {max} may be too small.",
      warn_out_bottom_single: "For bottoms size {bas_saisi}, even our {max} may be too small at the hips.",
      warn_out_approx: "For top size {haut_saisi}, even our {max} may be too small.",
      warn_compromise: "For {bonnet} cups, we picked the size that fits the cup. The band will be loose.",
      warn_capped_top: "This style only goes up to {max}. For size {sg}, the cup may be snug.",
      warn_capped_bottom: "This style only goes up to {max}. For bottoms size {bas_saisi}, it may be too small.",
      warn_capped_generic: "This style only goes up to {max}. Your size would be {taille}, so {max} may be too small.",
      warn_oos_single: "Size {taille} is sold out in this style. We don't recommend taking another size instead.",
      warn_oos_set: "Top {haut} · bottom {bas}: this combination is sold out in this style. We don't recommend taking another size instead.",
      warn_oos_frontier: "Size {taille} is sold out in this style. Size {autre} is available.",
      warn_body_top_bigger: "Top {haut}, bottom {bas}: a bodysuit will be a compromise. In {taille}, it fits your bust and will be loose at the hips.",
      warn_body_bottom_bigger: "Top {haut}, bottom {bas}: a bodysuit will be a compromise. In {taille}, it fits your hips and will be too big at the bust.",
      warn_body_alt: "With a set, you pick one size for the top and another for the bottom.",
      warn_body_alt_btn: "Shop sets",
      warn_runs_small: "This style runs small. We recommend {grande} rather than {petite}.",
      warn_limit_bottom: "At size {bas_saisi}, you're at the top of our {max}. The bottom may be snug.",
      warn_limit_bottom_single: "At size {bas_saisi}, you're at the top of our {max}. It may be snug at the hips.",
      warn_cup_tight: "In {taille}, the band fits. The cup may be a little snug for size {sg}.",
      warn_cup_tight_approx: "In {taille}, the top may be a little snug at the bust.",
      warn_cup_a_smallest: "With {bonnet} cups, the S cup may gap a little. We don't have a smaller cup.",
      warn_cup_a_other: "With {bonnet} cups, the {taille} cup may gap a little.",
      warn_gape_approx: "In {taille}, the cup may gap a little.",
      cta_set_btn: "Select top {haut} · bottom {bas}",
      cta_body_btn: "Select size {taille}",
      cta_close_btn: "Close",
      cta_anyway_btn: "Select {taille} anyway",
      cta_anyway_set_btn: "Select top {haut} · bottom {bas} anyway",
      apply_failed: "We couldn't select your size. Please choose {tailles} on the product page.",
      apply_failed_soldout: "This size just sold out in this style.",
      apply_sizes_set: "top {haut} and bottom {bas}",
      apply_sizes_single: "size {taille}",
      reassurance: "Exchange within 14 days",
      memory_info: "Your size is saved on this device so we can preselect it on other styles. You can change or clear it anytime.",
      memory_clear_btn: "Clear",
      aria_result_set: "Recommended size: top {haut}, bottom {bas}.",
      aria_result_body: "Recommended size: {taille}."
    },
    de: {
      card_size_set: "Ihre Größe: oben {top} · unten {bottom}",
      card_size_single: "Ihre Größe: {size}",
      card_soldout: "Ihre Größe {size} ist ausverkauft",
      card_not_advised: "Größe bei diesem Modell prüfen",
      card_out: "Keine Größenempfehlung für dieses Modell",
      card_edit: "Ändern",
      card_sub: "Beantworten Sie ein paar Fragen und erhalten Sie Ihre ideale Größe.",
      dialog_title: "Meine Größe finden",
      progress: "Schritt {n} von {total}",
      close: "Größenberater schließen",
      previous: "Zurück",
      next: "Weiter",
      see_result_btn: "Meine Größe anzeigen",
      edit_answers: "Antworten ändern",
      profile_title: "Ihr Profil",
      profile_sub: "Größe, Gewicht und Alter: drei Angaben für den Anfang.",
      height_label: "Größe",
      weight_label: "Gewicht",
      age_label: "Alter",
      unit_cm: "cm",
      unit_ft: "Fuß",
      unit_in: "Zoll",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "Jahre",
      unit_choice_aria: "Einheit",
      step_minus_aria: "{champ}: verringern",
      step_plus_aria: "{champ}: erhöhen",
      belly_title: "Welcher Bauch ähnelt Ihrem am meisten?",
      belly_flat: "Flach",
      belly_average: "Mittel",
      belly_round: "Mit Rundungen",
      hips_title: "Welche Hüften ähneln Ihren am meisten?",
      hips_narrow: "Schmal",
      hips_average: "Mittel",
      hips_curved: "Kurvig",
      seat_title: "Welcher Po ähnelt Ihrem am meisten?",
      seat_flat: "Flach",
      seat_average: "Mittel",
      seat_round: "Rund",
      region_current: "{systeme_titre} · z. B. {exemple}",
      region_change_btn: "Ändern",
      region_picker_title: "Welche Größen tragen Sie?",
      region_fr: "Französische Größen",
      region_fr_countries: "Frankreich, Belgien, Spanien",
      region_eu: "Deutsche Größen",
      region_eu_countries: "Deutschland, Österreich, Schweiz, Niederlande, Dänemark, Schweden",
      region_it: "Italienische Größen",
      region_it_countries: "Italien",
      region_us: "US-Größen",
      region_us_countries: "USA, Kanada",
      region_uk: "UK-Größen",
      region_uk_countries: "Großbritannien, Irland",
      region_au: "Australische Größen",
      region_au_countries: "Australien, Neuseeland",
      system_inline_fr: "französische Größen",
      system_inline_eu: "deutsche Größen",
      system_inline_it: "italienische Größen",
      system_inline_us: "US-Größen",
      system_inline_uk: "UK-Größen",
      system_inline_au: "australische Größen",
      bra_title: "Ihre BH-Größe",
      bra_sub: "Die Größe, die Sie am häufigsten tragen, auch wenn sie nicht perfekt sitzt.",
      band_size: "Unterbrustweite (die Zahl)",
      cup_size: "Cup (der Buchstabe)",
      band_plus_aria: "{n} oder größer",
      cup_plus_aria: "{c} oder größer",
      cup_small_aria: "AA oder A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} in Frankreich",
      equiv_eu: "{taille} in Deutschland",
      equiv_it: "{taille} in Italien",
      equiv_us: "{taille} in den USA",
      equiv_uk: "{taille} in Großbritannien",
      equiv_au: "{taille} in Australien",
      bra_unknown_link: "Ich kenne meine BH-Größe nicht",
      fallback_title: "Ohne BH-Größe",
      fallback_sub: "Zwei Fragen genügen. Das Ergebnis ist dann eine Schätzung.",
      fallback_top_label: "Ihre übliche Oberteilgröße",
      fallback_top_help: "Die Größe Ihrer T-Shirts oder Blusen.",
      fallback_bust_label: "An der Brust sitzen Ihre Oberteile meist",
      bust_small: "Etwas locker",
      bust_medium: "Genau richtig",
      bust_full: "Etwas eng",
      fallback_back_link: "BH-Größe eingeben",
      bottom_title: "Ihre übliche Slip- oder Hosengröße",
      bottom_help: "Die Größe, die Sie bei Hosen oder Slips meist tragen.",
      bottom_last_pill: "ab {limite}",
      error_bra_none: "Bitte wählen Sie Unterbrustweite und Cup.",
      error_band_missing: "Die Unterbrustweite fehlt noch (die Zahl).",
      error_cup_missing: "Der Cup fehlt noch (der Buchstabe).",
      error_top_missing: "Bitte wählen Sie Ihre Oberteilgröße.",
      error_bust_missing: "Bitte wählen Sie eine der drei Antworten.",
      error_bottom_missing: "Bitte wählen Sie Ihre Slip- oder Hosengröße.",
      error_height_cm: "Bitte geben Sie Ihre Größe an, zwischen {mini} und {maxi} cm.",
      error_height_ft: "Bitte geben Sie Ihre Größe an, zwischen {mini} und {maxi}.",
      error_weight_kg: "Bitte geben Sie Ihr Gewicht an, zwischen {mini} und {maxi} kg.",
      error_weight_lb: "Bitte geben Sie Ihr Gewicht an, zwischen {mini} und {maxi} lb.",
      error_age: "Bitte geben Sie Ihr Alter an, zwischen {mini} und {maxi} Jahren.",
      error_morpho_missing: "Bitte wählen Sie die Form, die Ihnen am ähnlichsten ist.",
      error_generic: "Das hat nicht geklappt. Bitte prüfen Sie Ihre Antworten und versuchen Sie es erneut.",
      result_title: "Ihre perfekte Größe",
      result_out_title: "Dieses Modell könnte zu klein sein",
      result_compromise_title: "Dieses Modell ist ein Kompromiss",
      result_none_title: "Ihre Größe führen wir leider nicht",
      result_capped_title: "Dieses Modell gibt es nur bis {max}",
      result_oos_title: "Ihre Größe ist ausverkauft",
      top_size: "Oben",
      bottom_size: "Unten",
      body_size: "Body",
      single_size: "Größe",
      result_none_value: "-",
      result_max_tag: "Unsere größte Größe",
      result_closest_tag: "Nächstliegende Größe",
      result_none_tag: "Keine Größe",
      result_capped_tag: "Hier nicht erhältlich",
      result_oos_tag: "Ausverkauft",
      result_fit_line: "Passt perfekt zu Ihrer Figur",
      social_proof_single: "Kundinnen mit Ihrer Figur wählen diese Größe",
      social_proof_set: "Kundinnen mit Ihrer Figur wählen diese Größen für ihr Set",
      result_why: "Berechnet aus Ihrer BH-Größe {sg} und Ihrer Hosengröße {bas_saisi}.",
      result_why_system: "Berechnet aus Ihrer BH-Größe {sg} ({systeme}) und Ihrer Hosengröße {bas_saisi}.",
      result_why_fallback: "Geschätzt aus Ihrer Oberteilgröße {haut_saisi}, Ihren Antworten und Ihrer Hosengröße {bas_saisi}.",
      result_why_profile: "Berechnet aus Ihrem Profil, Ihrer BH-Größe {sg} und Ihrer Hosengröße {bas_saisi}.",
      result_why_profile_system: "Berechnet aus Ihrem Profil, Ihrer BH-Größe {sg} ({systeme}) und Ihrer Hosengröße {bas_saisi}.",
      result_why_profile_fallback: "Geschätzt aus Ihrem Profil, Ihrer Oberteilgröße {haut_saisi}, Ihren Antworten und Ihrer Hosengröße {bas_saisi}.",
      result_fallback_help: "Das ist eine Schätzung: Ohne BH-Größe ist die Berechnung weniger genau.",
      tiebreak_top_title: "Beim Oberteil liegen Sie zwischen {petite} und {grande}.",
      tiebreak_single_title: "Sie liegen zwischen {petite} und {grande}.",
      tiebreak_advised_badge: "Empfohlen",
      tiebreak_hi_advised_help: "Wenn Ihr BH in {sg} gut sitzt oder eng ist.",
      tiebreak_lo_other_help: "Wenn Ihr BH in {sg} etwas zu groß ist.",
      tiebreak_lo_advised_help: "Wenn Ihr BH in {sg} gut sitzt oder etwas zu groß ist.",
      tiebreak_hi_other_help: "Wenn Ihr BH in {sg} eng sitzt.",
      tiebreak_hi_advised_help_approx: "Wenn Ihre Oberteile gut sitzen oder eng sind.",
      tiebreak_lo_other_help_approx: "Wenn Ihre Oberteile oft etwas zu groß sind.",
      tiebreak_lo_advised_help_approx: "Wenn Ihre Oberteile gut sitzen oder etwas zu groß sind.",
      tiebreak_hi_other_help_approx: "Wenn Ihre Oberteile oft eng sitzen.",
      warn_none_cup: "Unsere Größen gehen bis {max}. Bei {sg} ist der Cup in {max} zu klein.",
      warn_none_band: "Unsere Größen gehen bis {max}. Bei Unterbrustweite {tour} lässt sich der Verschluss nicht schließen.",
      warn_none_approx: "Unsere Größen gehen bis {max}. Bei Oberteilgröße {haut_saisi} ist das zu klein.",
      warn_none_bottom: "Unsere Unterteile gehen bis {max}. Bei Größe {bas_saisi} ist das zu klein.",
      warn_none_bottom_single: "Unsere Größen gehen bis {max}. Bei Hosengröße {bas_saisi} ist das zu klein.",
      warn_out_frank: "Das sagen wir Ihnen lieber vor der Bestellung.",
      warn_out_cup_max: "Bei {sg} könnte selbst unsere {max} am Cup zu klein sein.",
      warn_out_cup: "Bei {sg} könnte der Cup in {taille} zu klein sein.",
      warn_out_band: "Bei Unterbrustweite {tour} könnte selbst unsere {max} zu kurz zum Schließen sein.",
      warn_out_bottom: "Bei Hosengröße {bas_saisi} könnte selbst unsere {max} zu klein sein.",
      warn_out_bottom_single: "Bei Hosengröße {bas_saisi} könnte selbst unsere {max} an der Hüfte zu klein sein.",
      warn_out_approx: "Bei Oberteilgröße {haut_saisi} könnte selbst unsere {max} zu klein sein.",
      warn_compromise: "Bei Cup {bonnet} haben wir die Größe gewählt, die am Cup passt. Das Unterbrustband sitzt dann locker.",
      warn_capped_top: "Dieses Modell gibt es nur bis {max}. Bei {sg} könnte der Cup knapp sitzen.",
      warn_capped_bottom: "Dieses Modell gibt es nur bis {max}. Bei Hosengröße {bas_saisi} könnte es zu klein sein.",
      warn_capped_generic: "Dieses Modell gibt es nur bis {max}. Ihre Größe wäre {taille}: {max} könnte zu klein sein.",
      warn_oos_single: "Größe {taille} ist bei diesem Modell ausverkauft. Nehmen Sie lieber keine andere Größe als Ersatz.",
      warn_oos_set: "Oben {haut} · unten {bas}: Diese Kombination ist bei diesem Modell ausverkauft. Nehmen Sie lieber keine andere Größe als Ersatz.",
      warn_oos_frontier: "Größe {taille} ist bei diesem Modell ausverkauft. Größe {autre} ist verfügbar.",
      warn_body_top_bigger: "Oben {haut}, unten {bas}: Ein Body ist hier ein Kompromiss. In {taille} passt er an der Brust und sitzt an der Hüfte locker.",
      warn_body_bottom_bigger: "Oben {haut}, unten {bas}: Ein Body ist hier ein Kompromiss. In {taille} passt er an der Hüfte und ist an der Brust zu groß.",
      warn_body_alt: "Bei einem Set wählen Sie oben und unten jeweils die passende Größe.",
      warn_body_alt_btn: "Sets ansehen",
      warn_runs_small: "Dieses Modell fällt klein aus. Wir empfehlen {grande} statt {petite}.",
      warn_limit_bottom: "Mit {bas_saisi} liegen Sie an der Grenze unserer {max}. Das Unterteil könnte knapp sitzen.",
      warn_limit_bottom_single: "Mit {bas_saisi} liegen Sie an der Grenze unserer {max}. An der Hüfte könnte es knapp sitzen.",
      warn_cup_tight: "In {taille} passt die Unterbrustweite. Der Cup könnte bei {sg} etwas knapp sitzen.",
      warn_cup_tight_approx: "In {taille} könnte das Oberteil an der Brust etwas knapp sitzen.",
      warn_cup_a_smallest: "Bei Cup {bonnet} könnte der Cup in S etwas abstehen. Einen kleineren Cup haben wir nicht.",
      warn_cup_a_other: "Bei Cup {bonnet} könnte der Cup in {taille} etwas abstehen.",
      warn_gape_approx: "In {taille} könnte der Cup etwas abstehen.",
      cta_set_btn: "Oben {haut} · unten {bas} wählen",
      cta_body_btn: "Größe {taille} wählen",
      cta_close_btn: "Schließen",
      cta_anyway_btn: "Trotzdem {taille} wählen",
      cta_anyway_set_btn: "Trotzdem oben {haut} · unten {bas} wählen",
      apply_failed: "Die Größe ließ sich nicht auswählen. Bitte wählen Sie {tailles} direkt auf der Produktseite.",
      apply_failed_soldout: "Diese Größe ist bei diesem Modell soeben ausverkauft.",
      apply_sizes_set: "oben {haut} und unten {bas}",
      apply_sizes_single: "Größe {taille}",
      reassurance: "Erstattung oder Umtausch innerhalb von 14 Tagen",
      memory_info: "Ihre Größe bleibt auf diesem Gerät gespeichert und wird bei anderen Modellen vorausgewählt. Sie können sie jederzeit ändern oder löschen.",
      memory_clear_btn: "Löschen",
      aria_result_set: "Empfohlene Größe: oben {haut}, unten {bas}.",
      aria_result_body: "Empfohlene Größe: {taille}."
    },
    nl: {
      card_size_set: "Jouw maat: top {top} · broekje {bottom}",
      card_size_single: "Jouw maat: {size}",
      card_soldout: "Jouw maat {size} is uitverkocht",
      card_not_advised: "Check je maat voor dit model",
      card_out: "Geen maatadvies voor dit model",
      card_edit: "Wijzigen",
      card_sub: "Beantwoord een paar vragen en ontdek je ideale maat.",
      dialog_title: "Vind mijn maat",
      progress: "Stap {n} van {total}",
      close: "Maatzoeker sluiten",
      previous: "Terug",
      next: "Volgende",
      see_result_btn: "Bekijk mijn maat",
      edit_answers: "Antwoorden wijzigen",
      profile_title: "Jouw profiel",
      profile_sub: "Lengte, gewicht en leeftijd: drie gegevens om te beginnen.",
      height_label: "Lengte",
      weight_label: "Gewicht",
      age_label: "Leeftijd",
      unit_cm: "cm",
      unit_ft: "voet",
      unit_in: "inch",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "jaar",
      unit_choice_aria: "Eenheid",
      step_minus_aria: "{champ}: verlagen",
      step_plus_aria: "{champ}: verhogen",
      belly_title: "Welke buik lijkt het meest op die van jou?",
      belly_flat: "Plat",
      belly_average: "Gemiddeld",
      belly_round: "Met rondingen",
      hips_title: "Welke heupen lijken het meest op die van jou?",
      hips_narrow: "Smal",
      hips_average: "Gemiddeld",
      hips_curved: "Rond",
      seat_title: "Welke billen lijken het meest op die van jou?",
      seat_flat: "Plat",
      seat_average: "Gemiddeld",
      seat_round: "Rond",
      region_current: "{systeme_titre} · bv. {exemple}",
      region_change_btn: "Wijzigen",
      region_picker_title: "Welke maten gebruik je?",
      region_fr: "Franse maten",
      region_fr_countries: "Frankrijk, België, Spanje",
      region_eu: "EU-maten",
      region_eu_countries: "Nederland, Duitsland, Oostenrijk, Zwitserland, Denemarken, Zweden",
      region_it: "Italiaanse maten",
      region_it_countries: "Italië",
      region_us: "US-maten",
      region_us_countries: "Verenigde Staten, Canada",
      region_uk: "UK-maten",
      region_uk_countries: "Verenigd Koninkrijk, Ierland",
      region_au: "Australische maten",
      region_au_countries: "Australië, Nieuw-Zeeland",
      system_inline_fr: "Franse maten",
      system_inline_eu: "EU-maten",
      system_inline_it: "Italiaanse maten",
      system_inline_us: "US-maten",
      system_inline_uk: "UK-maten",
      system_inline_au: "Australische maten",
      bra_title: "Je bh-maat",
      bra_sub: "De maat die je het vaakst draagt, ook als die niet perfect zit.",
      band_size: "Omvang (het cijfer)",
      cup_size: "Cup (de letter)",
      band_plus_aria: "{n} of meer",
      cup_plus_aria: "{c} of groter",
      cup_small_aria: "AA of A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} in Frankrijk",
      equiv_eu: "EU-maat {taille}",
      equiv_it: "{taille} in Italië",
      equiv_us: "{taille} in de VS",
      equiv_uk: "{taille} in het VK",
      equiv_au: "{taille} in Australië",
      bra_unknown_link: "Ik weet mijn maat niet",
      fallback_title: "Zonder bh-maat",
      fallback_sub: "Twee vragen zijn genoeg. Het resultaat is een schatting.",
      fallback_top_label: "Je gebruikelijke maat in tops",
      fallback_top_help: "De maat van je T-shirts of blouses.",
      fallback_bust_label: "Bij de borst zitten je tops vaak",
      bust_small: "Wat ruim",
      bust_medium: "Precies goed",
      bust_full: "Wat strak",
      fallback_back_link: "Mijn bh-maat invullen",
      bottom_title: "Je gebruikelijke broekmaat",
      bottom_help: "De maat van je broeken of slips.",
      bottom_last_pill: "{limite} of meer",
      error_bra_none: "Kies je omvang en je cup.",
      error_band_missing: "Je omvang (het cijfer) ontbreekt nog.",
      error_cup_missing: "Je cup (de letter) ontbreekt nog.",
      error_top_missing: "Kies je maat in tops.",
      error_bust_missing: "Kies een van de drie antwoorden.",
      error_bottom_missing: "Kies je broekmaat.",
      error_height_cm: "Vul je lengte in, tussen {mini} en {maxi} cm.",
      error_height_ft: "Vul je lengte in, tussen {mini} en {maxi}.",
      error_weight_kg: "Vul je gewicht in, tussen {mini} en {maxi} kg.",
      error_weight_lb: "Vul je gewicht in, tussen {mini} en {maxi} lb.",
      error_age: "Vul je leeftijd in, tussen {mini} en {maxi} jaar.",
      error_morpho_missing: "Kies de vorm die het meest op die van jou lijkt.",
      error_generic: "De berekening is niet gelukt. Check je antwoorden en probeer het opnieuw.",
      result_title: "Jouw ideale maat",
      result_out_title: "Dit model is waarschijnlijk te klein",
      result_compromise_title: "Dit model wordt een compromis",
      result_none_title: "We hebben jouw maat niet",
      result_capped_title: "Dit model gaat tot maat {max}",
      result_oos_title: "Jouw maat is uitverkocht",
      top_size: "Top",
      bottom_size: "Broekje",
      body_size: "Body",
      single_size: "Maat",
      result_none_value: "-",
      result_max_tag: "Onze grootste maat",
      result_closest_tag: "Komt het dichtst in de buurt",
      result_none_tag: "Geen maat",
      result_capped_tag: "Niet beschikbaar in dit model",
      result_oos_tag: "Uitverkocht",
      result_fit_line: "Sluit perfect aan op jouw figuur",
      social_proof_single: "Onze klanten met jouw figuur kiezen deze maat",
      social_proof_set: "Onze klanten met jouw figuur kiezen deze maten voor hun set",
      result_why: "Berekend op basis van je bh-maat {sg} en je broekmaat {bas_saisi}.",
      result_why_system: "Berekend op basis van je bh-maat {sg} ({systeme}) en je broekmaat {bas_saisi}.",
      result_why_fallback: "Geschat op basis van je maat in tops {haut_saisi}, je antwoorden en je broekmaat {bas_saisi}.",
      result_why_profile: "Berekend op basis van je profiel, je bh-maat {sg} en je broekmaat {bas_saisi}.",
      result_why_profile_system: "Berekend op basis van je profiel, je bh-maat {sg} ({systeme}) en je broekmaat {bas_saisi}.",
      result_why_profile_fallback: "Geschat op basis van je profiel, je maat in tops {haut_saisi}, je antwoorden en je broekmaat {bas_saisi}.",
      result_fallback_help: "Dit is een schatting: zonder bh-maat is de berekening minder precies.",
      tiebreak_top_title: "Voor de top zit je tussen {petite} en {grande}.",
      tiebreak_single_title: "Je zit tussen {petite} en {grande}.",
      tiebreak_advised_badge: "Aanbevolen",
      tiebreak_hi_advised_help: "Als je {sg} goed of strak zit.",
      tiebreak_lo_other_help: "Als je {sg} wat ruim zit.",
      tiebreak_lo_advised_help: "Als je {sg} goed of wat ruim zit.",
      tiebreak_hi_other_help: "Als je {sg} strak zit.",
      tiebreak_hi_advised_help_approx: "Als je tops goed of strak zitten.",
      tiebreak_lo_other_help_approx: "Als je tops vaak wat ruim zitten.",
      tiebreak_lo_advised_help_approx: "Als je tops goed of wat ruim zitten.",
      tiebreak_hi_other_help_approx: "Als je tops vaak strak zitten.",
      warn_none_cup: "Onze maten gaan tot {max}. Voor {sg} is de cup van maat {max} te klein.",
      warn_none_band: "Onze maten gaan tot {max}. Bij omvang {tour} krijg je hem niet dicht.",
      warn_none_approx: "Onze maten gaan tot {max}. Voor maat {haut_saisi} in tops is dat te klein.",
      warn_none_bottom: "Onze broekjes gaan tot {max}. Voor maat {bas_saisi} is dat te klein.",
      warn_none_bottom_single: "Onze maten gaan tot {max}. Voor broekmaat {bas_saisi} is dat te klein.",
      warn_out_frank: "Dat zeggen we je liever vóór je bestelt.",
      warn_out_cup_max: "Voor {sg} is zelfs onze {max} waarschijnlijk te klein in de cup.",
      warn_out_cup: "Voor {sg} is de cup van maat {taille} waarschijnlijk te klein.",
      warn_out_band: "Bij omvang {tour} is zelfs onze {max} waarschijnlijk te kort om te sluiten.",
      warn_out_bottom: "Voor broekmaat {bas_saisi} is zelfs onze {max} waarschijnlijk te klein.",
      warn_out_bottom_single: "Voor broekmaat {bas_saisi} is zelfs onze {max} waarschijnlijk te klein bij de heupen.",
      warn_out_approx: "Voor maat {haut_saisi} in tops is zelfs onze {max} waarschijnlijk te klein.",
      warn_compromise: "Voor cup {bonnet} kozen we de maat die bij de cup past. De band zit dan ruim.",
      warn_capped_top: "Dit model gaat tot maat {max}. Voor {sg} kan de cup krap zitten.",
      warn_capped_bottom: "Dit model gaat tot maat {max}. Voor broekmaat {bas_saisi} is dat waarschijnlijk te klein.",
      warn_capped_generic: "Dit model gaat tot maat {max}. Jouw maat zou {taille} zijn: {max} is waarschijnlijk te klein.",
      warn_oos_single: "Maat {taille} is uitverkocht in dit model. Kies liever geen andere maat.",
      warn_oos_set: "Top {haut} · broekje {bas}: deze combinatie is uitverkocht in dit model. Kies liever geen andere maat.",
      warn_oos_frontier: "Maat {taille} is uitverkocht in dit model. Maat {autre} is beschikbaar.",
      warn_body_top_bigger: "Top {haut}, broekje {bas}: een body wordt een compromis. In {taille} past hij bij de borst en zit hij ruim bij de heupen.",
      warn_body_bottom_bigger: "Top {haut}, broekje {bas}: een body wordt een compromis. In {taille} past hij bij de heupen en is hij te groot bij de borst.",
      warn_body_alt: "Bij een set kies je één maat voor boven en een andere voor onder.",
      warn_body_alt_btn: "Bekijk de sets",
      warn_runs_small: "Dit model valt klein: we raden {grande} aan in plaats van {petite}.",
      warn_limit_bottom: "Met maat {bas_saisi} zit je op de grens van onze {max}. Het broekje kan krap zitten.",
      warn_limit_bottom_single: "Met maat {bas_saisi} zit je op de grens van onze {max}. Hij kan krap zitten bij de heupen.",
      warn_cup_tight: "In {taille} klopt de omvang. De cup kan wat krap zijn voor {sg}.",
      warn_cup_tight_approx: "In {taille} kan de top wat krap zitten bij de borst.",
      warn_cup_a_smallest: "Bij cup {bonnet} kan de cup van maat S wat openstaan. Een kleinere cup hebben we niet.",
      warn_cup_a_other: "Bij cup {bonnet} kan de cup van maat {taille} wat openstaan.",
      warn_gape_approx: "In {taille} kan de cup wat openstaan.",
      cta_set_btn: "Kies top {haut} · broekje {bas}",
      cta_body_btn: "Kies maat {taille}",
      cta_close_btn: "Sluiten",
      cta_anyway_btn: "Toch maat {taille} kiezen",
      cta_anyway_set_btn: "Toch top {haut} · broekje {bas} kiezen",
      apply_failed: "De maat kon niet worden geselecteerd. Kies {tailles} op de productpagina.",
      apply_failed_soldout: "Deze maat is net uitverkocht in dit model.",
      apply_sizes_set: "top {haut} en broekje {bas}",
      apply_sizes_single: "maat {taille}",
      reassurance: "Geld terug of ruilen binnen 14 dagen",
      memory_info: "Je maat blijft op dit apparaat bewaard, zodat hij bij andere modellen al voor je klaarstaat. Je kunt hem altijd wijzigen of wissen.",
      memory_clear_btn: "Wissen",
      aria_result_set: "Aanbevolen maat: top {haut}, broekje {bas}.",
      aria_result_body: "Aanbevolen maat: {taille}."
    },
    it: {
      card_size_set: "La tua taglia: sopra {top} · sotto {bottom}",
      card_size_single: "La tua taglia: {size}",
      card_soldout: "La tua taglia {size} è esaurita",
      card_not_advised: "Taglia da verificare per questo modello",
      card_out: "Nessuna taglia consigliata per il modello",
      card_edit: "Modifica",
      card_sub: "Rispondi a qualche domanda e scopri la tua taglia ideale.",
      dialog_title: "Trova la mia taglia",
      progress: "Passaggio {n} di {total}",
      close: "Chiudi il calcolatore di taglia",
      previous: "Indietro",
      next: "Avanti",
      see_result_btn: "Vedi la mia taglia",
      edit_answers: "Modifica le risposte",
      profile_title: "Il tuo profilo",
      profile_sub: "Altezza, peso ed età: tre dati per iniziare.",
      height_label: "Altezza",
      weight_label: "Peso",
      age_label: "Età",
      unit_cm: "cm",
      unit_ft: "piedi",
      unit_in: "pollici",
      unit_kg: "kg",
      unit_lb: "libbre",
      unit_years: "anni",
      unit_choice_aria: "Unità",
      step_minus_aria: "{champ}: diminuisci",
      step_plus_aria: "{champ}: aumenta",
      belly_title: "Quale pancia somiglia di più alla tua?",
      belly_flat: "Piatta",
      belly_average: "Media",
      belly_round: "Arrotondata",
      hips_title: "Quali fianchi somigliano di più ai tuoi?",
      hips_narrow: "Stretti",
      hips_average: "Medi",
      hips_curved: "Morbidi",
      seat_title: "Quale sedere somiglia di più al tuo?",
      seat_flat: "Piatto",
      seat_average: "Medio",
      seat_round: "Rotondo",
      region_current: "{systeme_titre} · es. {exemple}",
      region_change_btn: "Cambia",
      region_picker_title: "Quali taglie usi?",
      region_fr: "Taglie francesi",
      region_fr_countries: "Francia, Belgio, Spagna",
      region_eu: "Taglie EU",
      region_eu_countries: "Germania, Paesi Bassi, Austria, Svizzera, Danimarca, Svezia, Polonia",
      region_it: "Taglie italiane",
      region_it_countries: "Italia",
      region_us: "Taglie US",
      region_us_countries: "Stati Uniti, Canada",
      region_uk: "Taglie UK",
      region_uk_countries: "Regno Unito, Irlanda",
      region_au: "Taglie australiane",
      region_au_countries: "Australia, Nuova Zelanda",
      system_inline_fr: "taglie francesi",
      system_inline_eu: "taglie EU",
      system_inline_it: "taglie italiane",
      system_inline_us: "taglie US",
      system_inline_uk: "taglie UK",
      system_inline_au: "taglie australiane",
      bra_title: "La tua taglia di reggiseno",
      bra_sub: "Quella che indossi più spesso, anche se non è perfetta.",
      band_size: "Giro sottoseno (il numero)",
      cup_size: "Coppa (la lettera)",
      band_plus_aria: "{n} o più",
      cup_plus_aria: "{c} o più",
      cup_small_aria: "AA o A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} in Francia",
      equiv_eu: "{taille} in Germania",
      equiv_it: "{taille} in Italia",
      equiv_us: "{taille} negli Stati Uniti",
      equiv_uk: "{taille} nel Regno Unito",
      equiv_au: "{taille} in Australia",
      bra_unknown_link: "Non conosco la mia taglia",
      fallback_title: "Senza taglia di reggiseno",
      fallback_sub: "Bastano due domande. Il risultato sarà una stima.",
      fallback_top_label: "La tua taglia abituale di maglia",
      fallback_top_help: "Quella delle tue t-shirt o camicette.",
      fallback_bust_label: "Sul seno, le tue maglie di solito sono",
      bust_small: "Un po' larghe",
      bust_medium: "Giuste",
      bust_full: "Un po' strette",
      fallback_back_link: "Inserisci la taglia di reggiseno",
      bottom_title: "La tua taglia abituale di pantaloni",
      bottom_help: "Quella dei tuoi pantaloni o dei tuoi vestiti.",
      bottom_last_pill: "{limite} e oltre",
      error_bra_none: "Scegli il giro sottoseno e la coppa.",
      error_band_missing: "Manca il giro sottoseno (il numero).",
      error_cup_missing: "Manca la coppa (la lettera).",
      error_top_missing: "Scegli la tua taglia di maglia.",
      error_bust_missing: "Scegli una delle tre risposte.",
      error_bottom_missing: "Scegli la tua taglia di pantaloni.",
      error_height_cm: "Indica la tua altezza, tra {mini} e {maxi} cm.",
      error_height_ft: "Indica la tua altezza, tra {mini} e {maxi}.",
      error_weight_kg: "Indica il tuo peso, tra {mini} e {maxi} kg.",
      error_weight_lb: "Indica il tuo peso, tra {mini} e {maxi} libbre.",
      error_age: "Indica la tua età, tra {mini} e {maxi} anni.",
      error_morpho_missing: "Scegli la forma che ti somiglia di più.",
      error_generic: "Il calcolo non è riuscito. Controlla le risposte e riprova.",
      result_title: "La tua taglia ideale",
      result_out_title: "Questo modello rischia di essere piccolo",
      result_compromise_title: "Questo modello sarà un compromesso",
      result_none_title: "Non abbiamo la tua taglia",
      result_capped_title: "Questo modello arriva alla {max}",
      result_oos_title: "La tua taglia è esaurita",
      top_size: "Sopra",
      bottom_size: "Sotto",
      body_size: "Body",
      single_size: "Taglia",
      result_none_value: "-",
      result_max_tag: "La nostra taglia più grande",
      result_closest_tag: "La più vicina",
      result_none_tag: "Nessuna taglia",
      result_capped_tag: "Non c'è in questo modello",
      result_oos_tag: "Esaurita",
      result_fit_line: "Si adatta perfettamente al tuo fisico",
      social_proof_single: "Le nostre clienti con il tuo fisico scelgono questa taglia",
      social_proof_set: "Le nostre clienti con il tuo fisico scelgono queste taglie per il completo",
      result_why: "Calcolata a partire dal tuo reggiseno {sg} e dalla tua taglia di pantaloni {bas_saisi}.",
      result_why_system: "Calcolata a partire dal tuo reggiseno {sg} ({systeme}) e dalla tua taglia di pantaloni {bas_saisi}.",
      result_why_fallback: "Stimata a partire dalla tua taglia di maglia {haut_saisi}, dalle tue risposte e dalla taglia di pantaloni {bas_saisi}.",
      result_why_profile: "Calcolata a partire dal tuo profilo, dal tuo reggiseno {sg} e dalla tua taglia di pantaloni {bas_saisi}.",
      result_why_profile_system: "Calcolata a partire dal tuo profilo, dal tuo reggiseno {sg} ({systeme}) e dalla tua taglia di pantaloni {bas_saisi}.",
      result_why_profile_fallback: "Stimata dal tuo profilo, dalla tua taglia di maglia {haut_saisi}, dalle tue risposte e dalla taglia di pantaloni {bas_saisi}.",
      result_fallback_help: "È una stima: senza la taglia di reggiseno il calcolo è meno preciso.",
      tiebreak_top_title: "Sopra, sei tra la {petite} e la {grande}.",
      tiebreak_single_title: "Sei tra la {petite} e la {grande}.",
      tiebreak_advised_badge: "Consigliata",
      tiebreak_hi_advised_help: "Se il tuo {sg} ti sta bene o ti stringe.",
      tiebreak_lo_other_help: "Se il tuo {sg} è un po' grande.",
      tiebreak_lo_advised_help: "Se il tuo {sg} ti sta bene o è un po' grande.",
      tiebreak_hi_other_help: "Se il tuo {sg} ti stringe.",
      tiebreak_hi_advised_help_approx: "Se le tue maglie ti stanno bene o ti stringono.",
      tiebreak_lo_other_help_approx: "Se le tue maglie sono spesso un po' grandi.",
      tiebreak_lo_advised_help_approx: "Se le tue maglie ti stanno bene o sono un po' grandi.",
      tiebreak_hi_other_help_approx: "Se le tue maglie ti stringono spesso.",
      warn_none_cup: "Le nostre taglie arrivano alla {max}. Per un {sg}, la coppa della {max} è troppo piccola.",
      warn_none_band: "Le nostre taglie arrivano alla {max}. Con un giro sottoseno {tour}, non si chiude.",
      warn_none_approx: "Le nostre taglie arrivano alla {max}. Per una taglia di maglia {haut_saisi}, è troppo piccola.",
      warn_none_bottom: "Sotto, le nostre taglie arrivano alla {max}. Per una taglia {bas_saisi}, è troppo piccola.",
      warn_none_bottom_single: "Le nostre taglie arrivano alla {max}. Per una taglia di pantaloni {bas_saisi}, è troppo piccola.",
      warn_out_frank: "Preferiamo dirtelo prima dell'ordine.",
      warn_out_cup_max: "Per un {sg}, anche la nostra {max} rischia di essere piccola di coppa.",
      warn_out_cup: "Per un {sg}, la coppa della {taille} rischia di essere troppo piccola.",
      warn_out_band: "Con un giro sottoseno {tour}, anche la nostra {max} rischia di essere troppo corta per chiudersi.",
      warn_out_bottom: "Per una taglia di pantaloni {bas_saisi}, anche la nostra {max} rischia di essere troppo piccola.",
      warn_out_bottom_single: "Per una taglia di pantaloni {bas_saisi}, anche la nostra {max} rischia di essere stretta sui fianchi.",
      warn_out_approx: "Per una taglia di maglia {haut_saisi}, anche la nostra {max} rischia di essere troppo piccola.",
      warn_compromise: "Per una coppa {bonnet}, abbiamo scelto la taglia giusta per la coppa. Il giro sottoseno sarà largo.",
      warn_capped_top: "Questo modello arriva alla {max}. Per un {sg}, rischia di essere giusto di coppa.",
      warn_capped_bottom: "Questo modello arriva alla {max}. Per una taglia di pantaloni {bas_saisi}, rischia di essere troppo piccolo.",
      warn_capped_generic: "Questo modello arriva alla {max}. La tua taglia sarebbe la {taille}: la {max} rischia di essere troppo piccola.",
      warn_oos_single: "La {taille} è esaurita per questo modello. Meglio non prendere un'altra taglia al suo posto.",
      warn_oos_set: "Sopra {haut} · sotto {bas}: questa combinazione è esaurita per questo modello. Meglio non prendere un'altra taglia al suo posto.",
      warn_oos_frontier: "La {taille} è esaurita per questo modello. La {autre} è disponibile.",
      warn_body_top_bigger: "Sopra {haut}, sotto {bas}: un body sarà un compromesso. In {taille} segue il seno e sarà largo sui fianchi.",
      warn_body_bottom_bigger: "Sopra {haut}, sotto {bas}: un body sarà un compromesso. In {taille} segue i fianchi e sarà troppo grande sul seno.",
      warn_body_alt: "Con un completo scegli una taglia sopra e un'altra sotto.",
      warn_body_alt_btn: "Vedi i completi",
      warn_runs_small: "Questo modello veste piccolo: consigliamo la {grande} invece della {petite}.",
      warn_limit_bottom: "Con la {bas_saisi} sei al limite della nostra {max}. Il sotto rischia di essere giusto.",
      warn_limit_bottom_single: "Con la {bas_saisi} sei al limite della nostra {max}. Rischia di essere giusto sui fianchi.",
      warn_cup_tight: "In {taille} il giro sottoseno corrisponde. La coppa rischia di essere un po' giusta per un {sg}.",
      warn_cup_tight_approx: "In {taille} il sopra rischia di essere un po' giusto sul seno.",
      warn_cup_a_smallest: "Con una coppa {bonnet}, la coppa della S rischia di fare un po' di vuoto. Non abbiamo una coppa più piccola.",
      warn_cup_a_other: "Con una coppa {bonnet}, la coppa della {taille} rischia di fare un po' di vuoto.",
      warn_gape_approx: "In {taille} la coppa rischia di fare un po' di vuoto.",
      cta_set_btn: "Scegli sopra {haut} · sotto {bas}",
      cta_body_btn: "Scegli la taglia {taille}",
      cta_close_btn: "Chiudi",
      cta_anyway_btn: "Scegli comunque la {taille}",
      cta_anyway_set_btn: "Scegli comunque sopra {haut} · sotto {bas}",
      apply_failed: "Non è stato possibile selezionare la taglia. Scegli {tailles} nella scheda prodotto.",
      apply_failed_soldout: "Questa taglia è appena andata esaurita per questo modello.",
      apply_sizes_set: "sopra {haut} e sotto {bas}",
      apply_sizes_single: "la taglia {taille}",
      reassurance: "Rimborso o cambio entro 14 giorni",
      memory_info: "La tua taglia resta salvata su questo dispositivo per preselezionarla sugli altri modelli. Puoi modificarla o cancellarla in qualsiasi momento.",
      memory_clear_btn: "Cancella",
      aria_result_set: "Taglia consigliata: sopra {haut}, sotto {bas}.",
      aria_result_body: "Taglia consigliata: {taille}."
    },
    pl: {
      card_size_set: "Twój rozmiar: góra {top} · dół {bottom}",
      card_size_single: "Twój rozmiar: {size}",
      card_soldout: "Twój rozmiar {size} jest wyprzedany",
      card_not_advised: "Sprawdź rozmiar dla tego modelu",
      card_out: "Brak polecanego rozmiaru dla tego modelu",
      card_edit: "Zmień",
      card_sub: "Odpowiedz na kilka pytań i poznaj swój idealny rozmiar.",
      dialog_title: "Znajdź mój rozmiar",
      progress: "Krok {n} z {total}",
      close: "Zamknij kalkulator rozmiaru",
      previous: "Wstecz",
      next: "Dalej",
      see_result_btn: "Zobacz mój rozmiar",
      edit_answers: "Zmień odpowiedzi",
      profile_title: "Twój profil",
      profile_sub: "Wzrost, waga i wiek: trzy informacje na początek.",
      height_label: "Wzrost",
      weight_label: "Waga",
      age_label: "Wiek",
      unit_cm: "cm",
      unit_ft: "stopy",
      unit_in: "cale",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "lat",
      unit_choice_aria: "Jednostka",
      step_minus_aria: "{champ}: zmniejsz",
      step_plus_aria: "{champ}: zwiększ",
      belly_title: "Który brzuch najbardziej przypomina Twój?",
      belly_flat: "Płaski",
      belly_average: "Średni",
      belly_round: "Zaokrąglony",
      hips_title: "Które biodra najbardziej przypominają Twoje?",
      hips_narrow: "Wąskie",
      hips_average: "Średnie",
      hips_curved: "Krągłe",
      seat_title: "Które pośladki najbardziej przypominają Twoje?",
      seat_flat: "Płaskie",
      seat_average: "Średnie",
      seat_round: "Okrągłe",
      region_current: "{systeme_titre} · np. {exemple}",
      region_change_btn: "Zmień",
      region_picker_title: "Jakich rozmiarów używasz?",
      region_fr: "Rozmiary francuskie",
      region_fr_countries: "Francja, Belgia, Hiszpania",
      region_eu: "Rozmiary EU",
      region_eu_countries: "Polska, Niemcy, Holandia, Austria, Szwajcaria, Dania, Szwecja",
      region_it: "Rozmiary włoskie",
      region_it_countries: "Włochy",
      region_us: "Rozmiary US",
      region_us_countries: "Stany Zjednoczone, Kanada",
      region_uk: "Rozmiary UK",
      region_uk_countries: "Wielka Brytania, Irlandia",
      region_au: "Rozmiary australijskie",
      region_au_countries: "Australia, Nowa Zelandia",
      system_inline_fr: "rozmiary francuskie",
      system_inline_eu: "rozmiary EU",
      system_inline_it: "rozmiary włoskie",
      system_inline_us: "rozmiary US",
      system_inline_uk: "rozmiary UK",
      system_inline_au: "rozmiary australijskie",
      bra_title: "Twój rozmiar biustonosza",
      bra_sub: "Ten, który nosisz najczęściej, nawet jeśli nie jest idealny.",
      band_size: "Obwód pod biustem (liczba)",
      cup_size: "Miseczka (litera)",
      band_plus_aria: "{n} lub więcej",
      cup_plus_aria: "{c} lub większa",
      cup_small_aria: "AA lub A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} we Francji",
      equiv_eu: "{taille} w Niemczech",
      equiv_it: "{taille} we Włoszech",
      equiv_us: "{taille} w USA",
      equiv_uk: "{taille} w Wielkiej Brytanii",
      equiv_au: "{taille} w Australii",
      bra_unknown_link: "Nie znam swojego rozmiaru",
      fallback_title: "Bez rozmiaru biustonosza",
      fallback_sub: "Wystarczą dwa pytania. Wynik będzie szacunkowy.",
      fallback_top_label: "Twój zwykły rozmiar góry",
      fallback_top_help: "Taki jak Twoich T-shirtów lub bluzek.",
      fallback_bust_label: "W biuście Twoje bluzki są zwykle",
      bust_small: "Trochę luźne",
      bust_medium: "W sam raz",
      bust_full: "Trochę ciasne",
      fallback_back_link: "Podaj rozmiar biustonosza",
      bottom_title: "Twój zwykły rozmiar dołu",
      bottom_help: "Taki jak Twoich spodni lub majtek.",
      bottom_last_pill: "{limite} i więcej",
      error_bra_none: "Wybierz obwód pod biustem i miseczkę.",
      error_band_missing: "Brakuje obwodu pod biustem (liczba).",
      error_cup_missing: "Brakuje miseczki (litera).",
      error_top_missing: "Wybierz swój rozmiar góry.",
      error_bust_missing: "Wybierz jedną z trzech odpowiedzi.",
      error_bottom_missing: "Wybierz swój rozmiar dołu.",
      error_height_cm: "Podaj swój wzrost, od {mini} do {maxi} cm.",
      error_height_ft: "Podaj swój wzrost, od {mini} do {maxi}.",
      error_weight_kg: "Podaj swoją wagę, od {mini} do {maxi} kg.",
      error_weight_lb: "Podaj swoją wagę, od {mini} do {maxi} lb.",
      error_age: "Podaj swój wiek, od {mini} do {maxi} lat.",
      error_morpho_missing: "Wybierz kształt najbardziej podobny do Twojego.",
      error_generic: "Obliczenie się nie powiodło. Sprawdź odpowiedzi i spróbuj ponownie.",
      result_title: "Twój idealny rozmiar",
      result_out_title: "Ten model może być za mały",
      result_compromise_title: "Ten model będzie kompromisem",
      result_none_title: "Nie mamy Twojego rozmiaru",
      result_capped_title: "Ten model kończy się na {max}",
      result_oos_title: "Twój rozmiar jest wyprzedany",
      top_size: "Góra",
      bottom_size: "Dół",
      body_size: "Body",
      single_size: "Rozmiar",
      result_none_value: "-",
      result_max_tag: "Nasz największy rozmiar",
      result_closest_tag: "Najbliższy",
      result_none_tag: "Brak rozmiaru",
      result_capped_tag: "Niedostępny w tym modelu",
      result_oos_tag: "Wyprzedany",
      result_fit_line: "Idealnie dopasowany do Twojej sylwetki",
      social_proof_single: "Nasze klientki o Twojej sylwetce wybierają ten rozmiar",
      social_proof_set: "Nasze klientki o Twojej sylwetce wybierają te rozmiary do kompletu",
      result_why: "Obliczony na podstawie Twojego biustonosza {sg} i rozmiaru dołu {bas_saisi}.",
      result_why_system: "Obliczony na podstawie Twojego biustonosza {sg} ({systeme}) i rozmiaru dołu {bas_saisi}.",
      result_why_fallback: "Oszacowany na podstawie Twojego rozmiaru góry {haut_saisi}, odpowiedzi i rozmiaru dołu {bas_saisi}.",
      result_why_profile: "Obliczony na podstawie Twojego profilu, biustonosza {sg} i rozmiaru dołu {bas_saisi}.",
      result_why_profile_system: "Obliczony na podstawie Twojego profilu, biustonosza {sg} ({systeme}) i rozmiaru dołu {bas_saisi}.",
      result_why_profile_fallback: "Oszacowany na podstawie Twojego profilu, rozmiaru góry {haut_saisi}, odpowiedzi i rozmiaru dołu {bas_saisi}.",
      result_fallback_help: "To szacunek: bez rozmiaru biustonosza obliczenie jest mniej dokładne.",
      tiebreak_top_title: "U góry jesteś między {petite} a {grande}.",
      tiebreak_single_title: "Jesteś między {petite} a {grande}.",
      tiebreak_advised_badge: "Polecany",
      tiebreak_hi_advised_help: "Jeśli Twój {sg} leży dobrze albo uciska.",
      tiebreak_lo_other_help: "Jeśli Twój {sg} jest trochę za duży.",
      tiebreak_lo_advised_help: "Jeśli Twój {sg} leży dobrze albo jest trochę za duży.",
      tiebreak_hi_other_help: "Jeśli Twój {sg} uciska.",
      tiebreak_hi_advised_help_approx: "Jeśli Twoje bluzki leżą dobrze albo są ciasne.",
      tiebreak_lo_other_help_approx: "Jeśli Twoje bluzki często są trochę za duże.",
      tiebreak_lo_advised_help_approx: "Jeśli Twoje bluzki leżą dobrze albo są trochę za duże.",
      tiebreak_hi_other_help_approx: "Jeśli Twoje bluzki często są ciasne.",
      warn_none_cup: "Nasze rozmiary kończą się na {max}. Przy {sg} miseczka w {max} jest za mała.",
      warn_none_band: "Nasze rozmiary kończą się na {max}. Przy obwodzie {tour} nie da się go zapiąć.",
      warn_none_approx: "Nasze rozmiary kończą się na {max}. Przy rozmiarze góry {haut_saisi} jest za mały.",
      warn_none_bottom: "Nasze doły kończą się na {max}. Przy rozmiarze {bas_saisi} jest za mały.",
      warn_none_bottom_single: "Nasze rozmiary kończą się na {max}. Przy rozmiarze dołu {bas_saisi} jest za mały.",
      warn_out_frank: "Wolimy powiedzieć Ci to przed zamówieniem.",
      warn_out_cup_max: "Przy {sg} nawet nasze {max} może być za małe w miseczce.",
      warn_out_cup: "Przy {sg} miseczka w {taille} może być za mała.",
      warn_out_band: "Przy obwodzie {tour} nawet nasze {max} może być za krótkie, żeby się zapiąć.",
      warn_out_bottom: "Przy rozmiarze dołu {bas_saisi} nawet nasze {max} może być za małe.",
      warn_out_bottom_single: "Przy rozmiarze dołu {bas_saisi} nawet nasze {max} może być za małe w biodrach.",
      warn_out_approx: "Przy rozmiarze góry {haut_saisi} nawet nasze {max} może być za małe.",
      warn_compromise: "Przy miseczce {bonnet} wybraliśmy rozmiar dopasowany do miseczki. Obwód będzie luźny.",
      warn_capped_top: "Ten model kończy się na {max}. Przy {sg} miseczka może być przyciasna.",
      warn_capped_bottom: "Ten model kończy się na {max}. Przy rozmiarze dołu {bas_saisi} może być za mały.",
      warn_capped_generic: "Ten model kończy się na {max}. Twój rozmiar to {taille}: {max} może być za małe.",
      warn_oos_single: "Rozmiar {taille} jest wyprzedany w tym modelu. Lepiej nie brać zamiast niego innego.",
      warn_oos_set: "Góra {haut} · dół {bas}: to połączenie jest wyprzedane w tym modelu. Lepiej nie brać zamiast niego innego rozmiaru.",
      warn_oos_frontier: "Rozmiar {taille} jest wyprzedany w tym modelu. Rozmiar {autre} jest dostępny.",
      warn_body_top_bigger: "Góra {haut}, dół {bas}: body będzie kompromisem. W {taille} dopasuje się do biustu i będzie luźne w biodrach.",
      warn_body_bottom_bigger: "Góra {haut}, dół {bas}: body będzie kompromisem. W {taille} dopasuje się do bioder i będzie za duże w biuście.",
      warn_body_alt: "W komplecie wybierasz jeden rozmiar na górę, a inny na dół.",
      warn_body_alt_btn: "Zobacz komplety",
      warn_runs_small: "Ten model ma zaniżoną rozmiarówkę: polecamy {grande} zamiast {petite}.",
      warn_limit_bottom: "Przy {bas_saisi} jesteś na granicy naszego {max}. Dół może być przyciasny.",
      warn_limit_bottom_single: "Przy {bas_saisi} jesteś na granicy naszego {max}. Może być przyciasny w biodrach.",
      warn_cup_tight: "W {taille} obwód się zgadza. Miseczka może być trochę za mała przy {sg}.",
      warn_cup_tight_approx: "W {taille} góra może być trochę za ciasna w biuście.",
      warn_cup_a_smallest: "Przy miseczce {bonnet} miseczka w S może lekko odstawać. Nie mamy mniejszej miseczki.",
      warn_cup_a_other: "Przy miseczce {bonnet} miseczka w {taille} może lekko odstawać.",
      warn_gape_approx: "W {taille} miseczka może lekko odstawać.",
      cta_set_btn: "Wybierz: góra {haut} · dół {bas}",
      cta_body_btn: "Wybierz rozmiar {taille}",
      cta_close_btn: "Zamknij",
      cta_anyway_btn: "Mimo to wybierz {taille}",
      cta_anyway_set_btn: "Mimo to wybierz: góra {haut} · dół {bas}",
      apply_failed: "Nie udało się zaznaczyć rozmiaru. Wybierz {tailles} na stronie produktu.",
      apply_failed_soldout: "Ten rozmiar właśnie się wyprzedał w tym modelu.",
      apply_sizes_set: "górę {haut} i dół {bas}",
      apply_sizes_single: "rozmiar {taille}",
      reassurance: "Zwrot pieniędzy lub wymiana w ciągu 14 dni",
      memory_info: "Twój rozmiar zostaje zapisany na tym urządzeniu, żeby zaznaczyć go od razu przy innych modelach. Możesz go zmienić lub usunąć w każdej chwili.",
      memory_clear_btn: "Usuń",
      aria_result_set: "Polecany rozmiar: góra {haut}, dół {bas}.",
      aria_result_body: "Polecany rozmiar: {taille}."
    },
    da: {
      card_size_set: "Din størrelse: overdel {top} · underdel {bottom}",
      card_size_single: "Din størrelse: {size}",
      card_soldout: "Din størrelse {size} er udsolgt",
      card_not_advised: "Tjek størrelsen på denne model",
      card_out: "Ingen anbefalet størrelse til denne model",
      card_edit: "Ret",
      card_sub: "Svar på et par spørgsmål, og find din ideelle størrelse.",
      dialog_title: "Find min størrelse",
      progress: "Trin {n} af {total}",
      close: "Luk størrelsesberegneren",
      previous: "Tilbage",
      next: "Næste",
      see_result_btn: "Se min størrelse",
      edit_answers: "Ret mine svar",
      profile_title: "Din profil",
      profile_sub: "Højde, vægt og alder: tre oplysninger til en start.",
      height_label: "Højde",
      weight_label: "Vægt",
      age_label: "Alder",
      unit_cm: "cm",
      unit_ft: "fod",
      unit_in: "tommer",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "år",
      unit_choice_aria: "Enhed",
      step_minus_aria: "{champ}: mindre",
      step_plus_aria: "{champ}: mere",
      belly_title: "Hvilken mave ligner mest din?",
      belly_flat: "Flad",
      belly_average: "Middel",
      belly_round: "Rund",
      hips_title: "Hvilke hofter ligner mest dine?",
      hips_narrow: "Smalle",
      hips_average: "Middel",
      hips_curved: "Kurvede",
      seat_title: "Hvilken numse ligner mest din?",
      seat_flat: "Flad",
      seat_average: "Middel",
      seat_round: "Rund",
      region_current: "{systeme_titre} · f.eks. {exemple}",
      region_change_btn: "Skift",
      region_picker_title: "Hvilke størrelser bruger du?",
      region_fr: "Franske størrelser",
      region_fr_countries: "Frankrig, Belgien, Spanien",
      region_eu: "EU-størrelser",
      region_eu_countries: "Danmark, Sverige, Tyskland, Holland, Østrig, Schweiz, Polen",
      region_it: "Italienske størrelser",
      region_it_countries: "Italien",
      region_us: "US-størrelser",
      region_us_countries: "USA, Canada",
      region_uk: "UK-størrelser",
      region_uk_countries: "Storbritannien, Irland",
      region_au: "Australske størrelser",
      region_au_countries: "Australien, New Zealand",
      system_inline_fr: "franske størrelser",
      system_inline_eu: "EU-størrelser",
      system_inline_it: "italienske størrelser",
      system_inline_us: "US-størrelser",
      system_inline_uk: "UK-størrelser",
      system_inline_au: "australske størrelser",
      bra_title: "Din bh-størrelse",
      bra_sub: "Den du oftest har på, også selvom den ikke sidder perfekt.",
      band_size: "Omkreds (tallet)",
      cup_size: "Skål (bogstavet)",
      band_plus_aria: "{n} eller større",
      cup_plus_aria: "{c} eller større",
      cup_small_aria: "AA eller A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} i Frankrig",
      equiv_eu: "{taille} i Tyskland",
      equiv_it: "{taille} i Italien",
      equiv_us: "{taille} i USA",
      equiv_uk: "{taille} i Storbritannien",
      equiv_au: "{taille} i Australien",
      bra_unknown_link: "Jeg kender ikke min størrelse",
      fallback_title: "Uden bh-størrelse",
      fallback_sub: "To spørgsmål er nok. Resultatet bliver et skøn.",
      fallback_top_label: "Din sædvanlige størrelse i overdele",
      fallback_top_help: "Den du bruger i T-shirts eller bluser.",
      fallback_bust_label: "Over brystet er dine overdele ofte",
      bust_small: "Lidt for store",
      bust_medium: "Lige tilpas",
      bust_full: "Lidt stramme",
      fallback_back_link: "Indtast min bh-størrelse",
      bottom_title: "Din sædvanlige buksestørrelse",
      bottom_help: "Den du bruger i bukser eller trusser.",
      bottom_last_pill: "{limite} og over",
      error_bra_none: "Vælg din omkreds og din skål.",
      error_band_missing: "Du mangler at vælge omkreds (tallet).",
      error_cup_missing: "Du mangler at vælge skål (bogstavet).",
      error_top_missing: "Vælg din størrelse i overdele.",
      error_bust_missing: "Vælg et af de tre svar.",
      error_bottom_missing: "Vælg din buksestørrelse.",
      error_height_cm: "Angiv din højde, mellem {mini} og {maxi} cm.",
      error_height_ft: "Angiv din højde, mellem {mini} og {maxi}.",
      error_weight_kg: "Angiv din vægt, mellem {mini} og {maxi} kg.",
      error_weight_lb: "Angiv din vægt, mellem {mini} og {maxi} lb.",
      error_age: "Angiv din alder, mellem {mini} og {maxi} år.",
      error_morpho_missing: "Vælg den form, der ligner dig mest.",
      error_generic: "Beregningen lykkedes ikke. Tjek dine svar, og prøv igen.",
      result_title: "Din ideelle størrelse",
      result_out_title: "Denne model bliver nok for lille",
      result_compromise_title: "Denne model bliver et kompromis",
      result_none_title: "Vi har ikke din størrelse",
      result_capped_title: "Denne model går kun til {max}",
      result_oos_title: "Din størrelse er udsolgt",
      top_size: "Overdel",
      bottom_size: "Underdel",
      body_size: "Body",
      single_size: "Størrelse",
      result_none_value: "-",
      result_max_tag: "Vores største størrelse",
      result_closest_tag: "Den nærmeste",
      result_none_tag: "Ingen størrelse",
      result_capped_tag: "Findes ikke i denne model",
      result_oos_tag: "Udsolgt",
      result_fit_line: "Passer perfekt til din figur",
      social_proof_single: "Vores kunder med din figur vælger denne størrelse",
      social_proof_set: "Vores kunder med din figur vælger disse størrelser til deres sæt",
      result_why: "Beregnet ud fra din bh-størrelse {sg} og din buksestørrelse {bas_saisi}.",
      result_why_system: "Beregnet ud fra din bh-størrelse {sg} ({systeme}) og din buksestørrelse {bas_saisi}.",
      result_why_fallback: "Anslået ud fra din størrelse i overdele {haut_saisi}, dine svar og din buksestørrelse {bas_saisi}.",
      result_why_profile: "Beregnet ud fra din profil, din bh-størrelse {sg} og din buksestørrelse {bas_saisi}.",
      result_why_profile_system: "Beregnet ud fra din profil, din bh-størrelse {sg} ({systeme}) og din buksestørrelse {bas_saisi}.",
      result_why_profile_fallback: "Anslået ud fra din profil, din størrelse i overdele {haut_saisi}, dine svar og din buksestørrelse {bas_saisi}.",
      result_fallback_help: "Det er et skøn: Uden bh-størrelse er beregningen mindre præcis.",
      tiebreak_top_title: "I overdelen ligger du mellem {petite} og {grande}.",
      tiebreak_single_title: "Du ligger mellem {petite} og {grande}.",
      tiebreak_advised_badge: "Anbefalet",
      tiebreak_hi_advised_help: "Hvis din {sg} sidder godt eller strammer.",
      tiebreak_lo_other_help: "Hvis din {sg} er lidt for stor.",
      tiebreak_lo_advised_help: "Hvis din {sg} sidder godt eller er lidt for stor.",
      tiebreak_hi_other_help: "Hvis din {sg} strammer.",
      tiebreak_hi_advised_help_approx: "Hvis dine overdele sidder godt eller strammer.",
      tiebreak_lo_other_help_approx: "Hvis dine overdele ofte er lidt for store.",
      tiebreak_lo_advised_help_approx: "Hvis dine overdele sidder godt eller er lidt for store.",
      tiebreak_hi_other_help_approx: "Hvis dine overdele ofte strammer.",
      warn_none_cup: "Vores størrelser går til {max}. Til en {sg} er skålen i {max} for lille.",
      warn_none_band: "Vores størrelser går til {max}. Med omkreds {tour} kan den ikke lukkes.",
      warn_none_approx: "Vores størrelser går til {max}. Til størrelse {haut_saisi} i overdele er den for lille.",
      warn_none_bottom: "Vores underdele går til {max}. Til størrelse {bas_saisi} er den for lille.",
      warn_none_bottom_single: "Vores størrelser går til {max}. Til buksestørrelse {bas_saisi} er den for lille.",
      warn_out_frank: "Det vil vi hellere sige, før du bestiller.",
      warn_out_cup_max: "Til en {sg} bliver selv vores {max} nok for lille i skålen.",
      warn_out_cup: "Til en {sg} bliver skålen i {taille} nok for lille.",
      warn_out_band: "Med omkreds {tour} bliver selv vores {max} nok for kort til at kunne lukkes.",
      warn_out_bottom: "Til buksestørrelse {bas_saisi} bliver selv vores {max} nok for lille.",
      warn_out_bottom_single: "Til buksestørrelse {bas_saisi} bliver selv vores {max} nok for lille over hofterne.",
      warn_out_approx: "Til størrelse {haut_saisi} i overdele bliver selv vores {max} nok for lille.",
      warn_compromise: "Til skål {bonnet} har vi valgt den størrelse, der passer i skålen. Den bliver løs i omkredsen.",
      warn_capped_top: "Denne model går kun til {max}. Til en {sg} kan skålen blive lidt lille.",
      warn_capped_bottom: "Denne model går kun til {max}. Til buksestørrelse {bas_saisi} bliver den nok for lille.",
      warn_capped_generic: "Denne model går kun til {max}. Din størrelse ville være {taille}: {max} bliver nok for lille.",
      warn_oos_single: "{taille} er udsolgt i denne model. Det er bedst ikke at vælge en anden størrelse i stedet.",
      warn_oos_set: "Overdel {haut} · underdel {bas}: Den kombination er udsolgt i denne model. Det er bedst ikke at vælge en anden størrelse i stedet.",
      warn_oos_frontier: "{taille} er udsolgt i denne model. {autre} er på lager.",
      warn_body_top_bigger: "Overdel {haut}, underdel {bas}: En body bliver et kompromis. I {taille} passer den over brystet og bliver løs over hofterne.",
      warn_body_bottom_bigger: "Overdel {haut}, underdel {bas}: En body bliver et kompromis. I {taille} passer den over hofterne og bliver for stor over brystet.",
      warn_body_alt: "Med et sæt vælger du én størrelse foroven og en anden forneden.",
      warn_body_alt_btn: "Se sættene",
      warn_runs_small: "Denne model er lille i størrelsen: Vi anbefaler {grande} frem for {petite}.",
      warn_limit_bottom: "Med {bas_saisi} ligger du på grænsen af vores {max}. Underdelen kan blive lidt stram.",
      warn_limit_bottom_single: "Med {bas_saisi} ligger du på grænsen af vores {max}. Den kan blive lidt stram over hofterne.",
      warn_cup_tight: "I {taille} passer omkredsen. Skålen kan blive lidt lille til en {sg}.",
      warn_cup_tight_approx: "I {taille} kan overdelen blive lidt stram over brystet.",
      warn_cup_a_smallest: "Med skål {bonnet} kan skålen i S gabe lidt. Vi har ikke en mindre skål.",
      warn_cup_a_other: "Med skål {bonnet} kan skålen i {taille} gabe lidt.",
      warn_gape_approx: "I {taille} kan skålen gabe lidt.",
      cta_set_btn: "Vælg overdel {haut} · underdel {bas}",
      cta_body_btn: "Vælg størrelse {taille}",
      cta_close_btn: "Luk",
      cta_anyway_btn: "Vælg {taille} alligevel",
      cta_anyway_set_btn: "Vælg overdel {haut} · underdel {bas} alligevel",
      apply_failed: "Størrelsen kunne ikke vælges. Vælg {tailles} på produktsiden.",
      apply_failed_soldout: "Denne størrelse er lige blevet udsolgt i denne model.",
      apply_sizes_set: "overdel {haut} og underdel {bas}",
      apply_sizes_single: "størrelse {taille}",
      reassurance: "Pengene tilbage eller ombytning inden for 14 dage",
      memory_info: "Din størrelse gemmes på denne enhed, så den er valgt på forhånd på de andre modeller. Du kan altid ændre eller slette den.",
      memory_clear_btn: "Slet",
      aria_result_set: "Anbefalet størrelse: overdel {haut}, underdel {bas}.",
      aria_result_body: "Anbefalet størrelse: {taille}."
    },
    sv: {
      card_size_set: "Din storlek: överdel {top} · underdel {bottom}",
      card_size_single: "Din storlek: {size}",
      card_soldout: "Din storlek {size} är slutsåld",
      card_not_advised: "Kolla storleken på den här modellen",
      card_out: "Ingen rekommenderad storlek för modellen",
      card_edit: "Ändra",
      card_sub: "Svara på några frågor och hitta din perfekta storlek.",
      dialog_title: "Hitta min storlek",
      progress: "Steg {n} av {total}",
      close: "Stäng storleksguiden",
      previous: "Tillbaka",
      next: "Nästa",
      see_result_btn: "Visa min storlek",
      edit_answers: "Ändra mina svar",
      profile_title: "Din profil",
      profile_sub: "Längd, vikt och ålder: tre uppgifter till att börja med.",
      height_label: "Längd",
      weight_label: "Vikt",
      age_label: "Ålder",
      unit_cm: "cm",
      unit_ft: "fot",
      unit_in: "tum",
      unit_kg: "kg",
      unit_lb: "lb",
      unit_years: "år",
      unit_choice_aria: "Enhet",
      step_minus_aria: "{champ}: minska",
      step_plus_aria: "{champ}: öka",
      belly_title: "Vilken mage liknar din mest?",
      belly_flat: "Platt",
      belly_average: "Medel",
      belly_round: "Rund",
      hips_title: "Vilka höfter liknar dina mest?",
      hips_narrow: "Smala",
      hips_average: "Medel",
      hips_curved: "Kurviga",
      seat_title: "Vilken rumpa liknar din mest?",
      seat_flat: "Platt",
      seat_average: "Medel",
      seat_round: "Rund",
      region_current: "{systeme_titre} · t.ex. {exemple}",
      region_change_btn: "Byt",
      region_picker_title: "Vilka storlekar använder du?",
      region_fr: "Franska storlekar",
      region_fr_countries: "Frankrike, Belgien, Spanien",
      region_eu: "EU-storlekar",
      region_eu_countries: "Sverige, Danmark, Tyskland, Nederländerna, Österrike, Schweiz, Polen",
      region_it: "Italienska storlekar",
      region_it_countries: "Italien",
      region_us: "US-storlekar",
      region_us_countries: "USA, Kanada",
      region_uk: "UK-storlekar",
      region_uk_countries: "Storbritannien, Irland",
      region_au: "Australiska storlekar",
      region_au_countries: "Australien, Nya Zeeland",
      system_inline_fr: "franska storlekar",
      system_inline_eu: "EU-storlekar",
      system_inline_it: "italienska storlekar",
      system_inline_us: "US-storlekar",
      system_inline_uk: "UK-storlekar",
      system_inline_au: "australiska storlekar",
      bra_title: "Din bh-storlek",
      bra_sub: "Den du oftast har på dig, även om den inte sitter perfekt.",
      band_size: "Omkrets (siffran)",
      cup_size: "Kupa (bokstaven)",
      band_plus_aria: "{n} eller större",
      cup_plus_aria: "{c} eller större",
      cup_small_aria: "AA eller A",
      equivalence: "{saisie} = {equiv_1} = {equiv_2}",
      equiv_fr: "{taille} i Frankrike",
      equiv_eu: "{taille} i Tyskland",
      equiv_it: "{taille} i Italien",
      equiv_us: "{taille} i USA",
      equiv_uk: "{taille} i Storbritannien",
      equiv_au: "{taille} i Australien",
      bra_unknown_link: "Jag vet inte min storlek",
      fallback_title: "Utan bh-storlek",
      fallback_sub: "Två frågor räcker. Resultatet blir en uppskattning.",
      fallback_top_label: "Din vanliga storlek i överdelar",
      fallback_top_help: "Den du har i t-shirts eller blusar.",
      fallback_bust_label: "Över bysten är dina överdelar ofta",
      bust_small: "Lite stora",
      bust_medium: "Lagom",
      bust_full: "Lite trånga",
      fallback_back_link: "Ange min bh-storlek",
      bottom_title: "Din vanliga byxstorlek",
      bottom_help: "Den du har i byxor eller trosor.",
      bottom_last_pill: "{limite} och upp",
      error_bra_none: "Välj din omkrets och din kupa.",
      error_band_missing: "Din omkrets (siffran) saknas.",
      error_cup_missing: "Din kupa (bokstaven) saknas.",
      error_top_missing: "Välj din storlek i överdelar.",
      error_bust_missing: "Välj ett av de tre svaren.",
      error_bottom_missing: "Välj din byxstorlek.",
      error_height_cm: "Ange din längd, mellan {mini} och {maxi} cm.",
      error_height_ft: "Ange din längd, mellan {mini} och {maxi}.",
      error_weight_kg: "Ange din vikt, mellan {mini} och {maxi} kg.",
      error_weight_lb: "Ange din vikt, mellan {mini} och {maxi} lb.",
      error_age: "Ange din ålder, mellan {mini} och {maxi} år.",
      error_morpho_missing: "Välj den form som liknar dig mest.",
      error_generic: "Beräkningen fungerade inte. Kolla dina svar och försök igen.",
      result_title: "Din perfekta storlek",
      result_out_title: "Modellen blir troligen för liten",
      result_compromise_title: "Modellen blir en kompromiss",
      result_none_title: "Vi har inte din storlek",
      result_capped_title: "Modellen finns bara upp till {max}",
      result_oos_title: "Din storlek är slutsåld",
      top_size: "Överdel",
      bottom_size: "Underdel",
      body_size: "Body",
      single_size: "Storlek",
      result_none_value: "-",
      result_max_tag: "Vår största storlek",
      result_closest_tag: "Den närmaste",
      result_none_tag: "Ingen storlek",
      result_capped_tag: "Finns inte i den här modellen",
      result_oos_tag: "Slutsåld",
      result_fit_line: "Passar din figur perfekt",
      social_proof_single: "Våra kunder med din figur väljer den här storleken",
      social_proof_set: "Våra kunder med din figur väljer de här storlekarna till sitt set",
      result_why: "Beräknat utifrån din bh-storlek {sg} och din byxstorlek {bas_saisi}.",
      result_why_system: "Beräknat utifrån din bh-storlek {sg} ({systeme}) och din byxstorlek {bas_saisi}.",
      result_why_fallback: "Uppskattat utifrån din storlek i överdelar {haut_saisi}, dina svar och din byxstorlek {bas_saisi}.",
      result_why_profile: "Beräknat utifrån din profil, din bh-storlek {sg} och din byxstorlek {bas_saisi}.",
      result_why_profile_system: "Beräknat utifrån din profil, din bh-storlek {sg} ({systeme}) och din byxstorlek {bas_saisi}.",
      result_why_profile_fallback: "Uppskattat utifrån din profil, din storlek i överdelar {haut_saisi}, dina svar och din byxstorlek {bas_saisi}.",
      result_fallback_help: "Det här är en uppskattning: utan bh-storlek blir beräkningen mindre exakt.",
      tiebreak_top_title: "Upptill ligger du mellan {petite} och {grande}.",
      tiebreak_single_title: "Du ligger mellan {petite} och {grande}.",
      tiebreak_advised_badge: "Rekommenderas",
      tiebreak_hi_advised_help: "Om din {sg} sitter bra eller stramar.",
      tiebreak_lo_other_help: "Om din {sg} är lite stor.",
      tiebreak_lo_advised_help: "Om din {sg} sitter bra eller är lite stor.",
      tiebreak_hi_other_help: "Om din {sg} stramar.",
      tiebreak_hi_advised_help_approx: "Om dina överdelar sitter bra eller stramar.",
      tiebreak_lo_other_help_approx: "Om dina överdelar ofta är lite stora.",
      tiebreak_lo_advised_help_approx: "Om dina överdelar sitter bra eller är lite stora.",
      tiebreak_hi_other_help_approx: "Om dina överdelar ofta stramar.",
      warn_none_cup: "Våra storlekar går upp till {max}. För {sg} är kupan i {max} för liten.",
      warn_none_band: "Våra storlekar går upp till {max}. Med omkrets {tour} går den inte att knäppa.",
      warn_none_approx: "Våra storlekar går upp till {max}. För storlek {haut_saisi} i överdelar är den för liten.",
      warn_none_bottom: "Våra underdelar går upp till {max}. För storlek {bas_saisi} är den för liten.",
      warn_none_bottom_single: "Våra storlekar går upp till {max}. För byxstorlek {bas_saisi} är den för liten.",
      warn_out_frank: "Det säger vi hellre innan du beställer.",
      warn_out_cup_max: "För {sg} blir även vår {max} troligen för liten i kupan.",
      warn_out_cup: "För {sg} blir kupan i {taille} troligen för liten.",
      warn_out_band: "Med omkrets {tour} blir även vår {max} troligen för kort för att gå att knäppa.",
      warn_out_bottom: "För byxstorlek {bas_saisi} blir även vår {max} troligen för liten.",
      warn_out_bottom_single: "För byxstorlek {bas_saisi} blir även vår {max} troligen för liten över höfterna.",
      warn_out_approx: "För storlek {haut_saisi} i överdelar blir även vår {max} troligen för liten.",
      warn_compromise: "För kupa {bonnet} har vi valt storleken som passar kupan. Den blir vid i omkretsen.",
      warn_capped_top: "Modellen finns bara upp till {max}. För {sg} kan kupan bli lite liten.",
      warn_capped_bottom: "Modellen finns bara upp till {max}. För byxstorlek {bas_saisi} blir den troligen för liten.",
      warn_capped_generic: "Modellen finns bara upp till {max}. Din storlek vore {taille}: {max} blir troligen för liten.",
      warn_oos_single: "{taille} är slutsåld i den här modellen. Välj helst inte en annan storlek i stället.",
      warn_oos_set: "Överdel {haut} · underdel {bas}: den kombinationen är slutsåld i den här modellen. Välj helst inte en annan storlek i stället.",
      warn_oos_frontier: "{taille} är slutsåld i den här modellen. {autre} finns i lager.",
      warn_body_top_bigger: "Överdel {haut}, underdel {bas}: en body blir en kompromiss. I {taille} passar den över bysten och blir vid över höfterna.",
      warn_body_bottom_bigger: "Överdel {haut}, underdel {bas}: en body blir en kompromiss. I {taille} passar den över höfterna och blir för stor över bysten.",
      warn_body_alt: "Med ett set väljer du en storlek upptill och en annan nedtill.",
      warn_body_alt_btn: "Se seten",
      warn_runs_small: "Modellen är liten i storleken: vi rekommenderar {grande} i stället för {petite}.",
      warn_limit_bottom: "Med {bas_saisi} ligger du på gränsen för vår {max}. Underdelen kan bli lite trång.",
      warn_limit_bottom_single: "Med {bas_saisi} ligger du på gränsen för vår {max}. Den kan bli lite trång över höfterna.",
      warn_cup_tight: "I {taille} stämmer omkretsen. Kupan kan bli lite liten för {sg}.",
      warn_cup_tight_approx: "I {taille} kan överdelen bli lite trång över bysten.",
      warn_cup_a_smallest: "Med kupa {bonnet} kan kupan i S glipa lite. Vi har ingen mindre kupa.",
      warn_cup_a_other: "Med kupa {bonnet} kan kupan i {taille} glipa lite.",
      warn_gape_approx: "I {taille} kan kupan glipa lite.",
      cta_set_btn: "Välj överdel {haut} · underdel {bas}",
      cta_body_btn: "Välj storlek {taille}",
      cta_close_btn: "Stäng",
      cta_anyway_btn: "Välj {taille} ändå",
      cta_anyway_set_btn: "Välj överdel {haut} · underdel {bas} ändå",
      apply_failed: "Storleken kunde inte väljas. Välj {tailles} på produktsidan.",
      apply_failed_soldout: "Den här storleken tog precis slut i den här modellen.",
      apply_sizes_set: "överdel {haut} och underdel {bas}",
      apply_sizes_single: "storlek {taille}",
      reassurance: "Pengarna tillbaka eller byte inom 14 dagar",
      memory_info: "Din storlek sparas på den här enheten så att den är förvald på andra modeller. Du kan ändra eller ta bort den när du vill.",
      memory_clear_btn: "Ta bort",
      aria_result_set: "Rekommenderad storlek: överdel {haut}, underdel {bas}.",
      aria_result_body: "Rekommenderad storlek: {taille}."
    }
  };
  /* TEXTES:FIN */

  var api = root.NakedSizeTexts || {};
  for (var lang in TEXTS) if (Object.prototype.hasOwnProperty.call(TEXTS, lang)) api[lang] = TEXTS[lang];

  /** Texte d'une clé dans une langue (« de », « en-GB »…), variables {nom} remplacées. Repli : langue courte, puis français. */
  api.t = function (lang, key, vars) {
    var code = String(lang || 'fr').toLowerCase(), short = code.slice(0, 2);
    var tables = [api[code], api[short], api.fr], text = null;
    for (var i = 0; i < tables.length && text == null; i++) {
      if (tables[i] && typeof tables[i] === 'object' && typeof tables[i][key] === 'string') text = tables[i][key];
    }
    if (text == null) return '';
    return text.replace(/\{([a-z0-9_]+)\}/gi, function (all, name) {
      return vars && vars[name] != null ? String(vars[name]) : '';
    });
  };

  root.NakedSizeTexts = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
